import Vue from "vue";
import ViewerSingle from "./src/index";
import mixins from "../mixins";
Vue.mixin(mixins);
// 全局定义echarts
import ECharts from "vue-echarts";
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
//import 'echarts-liquidfill'
// import 'echarts-gl'
import ElementUI from "element-ui";
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI, { zhLocale });
Vue.component("v-chart", ECharts);

ViewerSingle.install = function (Vue) {
    Vue.component(ViewerSingle.name, ViewerSingle);
};

export default ViewerSingle;
